import __pages_import_0__ from "/src/pages/index.vue";
const __pages_import_1__ = () => import("/src/pages/feria/[paramID].vue");

const routes = [{"name":"index","path":"/","component":__pages_import_0__,"props":true},{"name":"feria-paramID","path":"/feria/:paramID","component":__pages_import_1__,"props":true}];

export default routes;